// For live ===========>
export const base_url = "https://digilocker.meon.co.in";
export const events_url = "https://pdf.meon.co.in";

// For UAT ================?
// export const base_url = "https://kycuat.meon.co.in";
// export const events_url = "";

// For local =================>
//export const base_url = "http://192.168.29.13:7000";
// export const events_url = "http://localhost:3001";
